import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseSafeFormView, BaseView, BaseText } from '@/components/base'
import { ChooseCryptoCurrencyList } from '@/features/add-money/select-currency'
import { StickyHeaderNavigation } from '@/components'

export const SelectCurrencyScreen: React.FC = () => {
  const { t } = useTranslation()

  return (
    <BaseSafeFormView
      style={{ paddingTop: 50 }}
      flex={1}
      bgColor="background.screen"
      className="h-full"
    >
      {/* Header Navigation */}
      <StickyHeaderNavigation />

      {/* Content */}
      <BaseView mt={16} px={13} flex={1} gap={20}>
        {/* Title */}
        <BaseText fontSize={28} fontFamily="semibold" color="label.default">
          {t('bottomSheets:selectCurrency.title')}
        </BaseText>

        {/* Currency List */}
        <ChooseCryptoCurrencyList />
      </BaseView>
    </BaseSafeFormView>
  )
}
